import { makeStyles, Theme } from '@material-ui/core/styles'

interface StyleProps {
  colors: {
    accentColor: string
    accentColorBackground: string
    cardAccentColor: string
  }
  matches: boolean
  matchesMobile: boolean
}

const stylesChannelAttendante = makeStyles<Theme, StyleProps>((theme) => ({
  main: {
    gap: '2.5rem',
    width: '100%',
    height: '100%',
    display: 'flex',
    padding: '2.5rem 0',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: theme.palette.common.white,
  },
  title: {
    fontWeight: 700,
    textAlign: 'center',
    textTransform: 'uppercase',
    fontSize: theme.typography.pxToRem(30),
    color: theme.palette.primary.main,
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(24),
    },
  },
  channelList: {
    gap: theme.typography.pxToRem(62),
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    maxWidth: '1420px',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    cursor: 'pointer',
    maxWidth: '121px',
    minHeight: '162px',
    maxHeight: '162px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  iconContainerPhone: {
    width: '100%',
    height: '100%',
    display: 'flex',
    cursor: 'pointer',
    maxWidth: '121px',
    minHeight: '200px',
    maxHeight: '200px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    width: '100%',
    color: '#fff',
    height: '100%',
    display: 'flex',
    padding: '1.8rem',
    maxWidth: '120px',
    maxHeight: '120px',
    borderRadius: '50%',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.primary.main,
  },
  titleChannel: {
    color: '#626E71',
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 700,
    marginTop: '1rem',
    textAlign: 'center',
    fontFamily: 'Roboto',
    lineHeight: '20px',
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
    textUnderlinePosition: 'from-font',
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(14),
    },
  },
  iconNavigate: {
    width: '100%',
    height: '100%',
    maxWidth: '36px',
    color: theme.palette.common.white,
  },
  iconNavite: {
    color: theme.palette.common.white,
    cursor: 'pointer',
    width: 32,
    height: 32,
    background: theme.palette.primary.main,
    padding: 0,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
  },
  buttonNavite: {
    color: '#fff',
    width: '32px',
    cursor: 'pointer',
    height: '32px',
    padding: 0,
    borderRadius: '50%',
    background: '#0467B8',
  },
  slider: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  sliderContainer: {
    gap: '2rem',
    width: '100%',
    height: '100%',
    display: 'flex',
    maxWidth: '1000px',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
  },
}))

export default stylesChannelAttendante
